import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-guarantee-check",
  "use": "icon-guarantee-check-usage",
  "viewBox": "0 0 27 27",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27 27\" id=\"icon-guarantee-check\"><path d=\"M13.5 0C20.956 0 27 6.044 27 13.5S20.956 27 13.5 27 0 20.956 0 13.5 6.044 0 13.5 0Zm5.64 8-8.19 8.261-3.09-3.105L6 15.026 10.95 20 21 9.87 19.14 8Z\" fill=\"#588D32\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol